// extracted by mini-css-extract-plugin
module.exports = {"navigation":"page-annexes_navigation__3rVcX","active":"page-annexes_active__Ffo6w","annexes-controls":"page-annexes_annexes-controls__3NGec"};